// DS: i3.47
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioMulti: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99658 4C6.99658 3.44772 7.4443 3 7.99658 3H12.4701C13.0224 3 13.4701 3.44772 13.4701 4C13.4701 4.55228 13.0224 5 12.4701 5H8.99658V14.9999H19V11.5297C19 10.9774 19.4477 10.5297 20 10.5297C20.5523 10.5297 21 10.9774 21 11.5297V15.9999C21 16.5521 20.5523 16.9999 20 16.9999H7.99658C7.4443 16.9999 6.99658 16.5521 6.99658 15.9999V4ZM17.1101 3.29289C17.5006 2.90237 18.1337 2.90237 18.5243 3.29289L20.7037 5.47229C20.8912 5.65983 20.9966 5.91418 20.9966 6.1794C20.9966 6.44461 20.8912 6.69897 20.7037 6.8865L15.0865 12.5037C14.893 12.6971 14.6287 12.8029 14.3552 12.7963L12.2784 12.746C11.7543 12.7333 11.329 12.318 11.3038 11.7944L11.2012 9.6653C11.1876 9.38368 11.2935 9.10942 11.4929 8.91005L17.1101 3.29289ZM17.8172 5.41421L13.2202 10.0112L13.2567 10.7691L13.9753 10.7865L18.5823 6.1794L17.8172 5.41421ZM4 6.99805L6 6.99838V8.99805H5V18.998H15V17.998H17V19.998C17 20.5503 16.5523 20.998 16 20.998H4C3.44772 20.998 3 20.5503 3 19.998V7.99805C3 7.44576 3.44772 6.99805 4 6.99805Z"
          fill="currentColor"
        />
      </svg>
    </IconWrap>
  );
};
StudioMulti.displayName = 'StudioMulti';

export default StudioMulti;
